import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const parkingTimeApi = createApi({
  reducerPath: 'parkingTimeApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['parkingTime'],
  endpoints: (builder) => ({
    findByParkingLocationId: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.HoursOfOperationController.findByParkingLocationId}${body.parkingLocationId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    save: builder.mutation({
      query(body) {
        return {
          url: body.payload.isEdit
            ? spotFinder.HoursOfOperationController.update
            : spotFinder.HoursOfOperationController.save,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

    update: builder.mutation({
      query(body) {
        return {
          url: spotFinder.HoursOfOperationController.update,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFindByParkingLocationIdMutation, useSaveMutation, useUpdateMutation } = parkingTimeApi;
